var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNophotoPatient = function SvgNophotoPatient(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5046",
    "data-name": "Grupo 5046",
    transform: "translate(-464 -231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icone_Paciente_admin_mobile_",
    "data-name": "Icone Paciente / admin (mobile)",
    transform: "translate(464 231)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5045",
    "data-name": "Grupo 5045",
    transform: "translate(151.902 -53.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4239",
    "data-name": "Caminho 4239",
    d: "M337.3,334.234a24.944,24.944,0,0,1-19.2-8.986,26.982,26.982,0,0,1,38.156-.238c.08.078.16.158.238.238A24.965,24.965,0,0,1,337.3,334.234Z",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4238",
    "data-name": "Caminho 4238",
    d: "M337.092,296.312a9.385,9.385,0,1,1-.03,0Z",
    fill: "#c1c1c1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNophotoPatient, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nophoto-patient.0dcadc41.svg";
export { ForwardRef as ReactComponent };